import { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, getMe } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMe = async () => {
      try {
        if (localStorage.getItem('token')) {
          const data = await getMe();
          setUser(data.user);
          localStorage.setItem('user', JSON.stringify(data.user));
        }
      } catch (err) {
        logout();
      }
    };
    fetchMe();
  }, []);

  const login = async (username, password) => {
    setLoading(true);
    try {
      const data = await apiLogin(username, password);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      setUser(data.user);
      return data;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const can = (permission) => {
    if (!user) return false;
    if (user.role === 'owner') return true;
    // Simplified client-side check — server enforces the real permissions
    const financePerms = ['clients.read', 'projects.read', 'subscriptions.read', 'subscriptions.write',
      'invoices.read', 'invoices.write', 'payments.write', 'expenses.read', 'expenses.write',
      'ai_tools.read', 'contracts.read', 'exchange_rates.write', 'reports.read'];
    const opsPerms = ['clients.read', 'projects.read', 'projects.write', 'subscriptions.read',
      'deliverables.write', 'invoices.read', 'contracts.read', 'contracts.write'];
    if (user.role === 'finance') return financePerms.includes(permission);
    if (user.role === 'ops') return opsPerms.includes(permission);
    return false;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
